var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("Header", { ref: "header" }),
        _c("img", {
          staticClass: "loading",
          attrs: { src: _vm.gameData.topBgImage, alt: "" },
        }),
        _c(
          "div",
          { staticClass: "item_Options points-item_Options" },
          [
            _c(
              "div",
              { staticClass: "content points-content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _c("div", { staticClass: "describe" }, [
                  _c("img", {
                    attrs: {
                      src: require("../assets/image/publicize.png"),
                      alt: "",
                    },
                  }),
                  _c("span", [_vm._v("|")]),
                  _c("p", { staticClass: "marquee" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("pointsDescribeText")))]),
                  ]),
                ]),
                _c("div", { staticClass: "position" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "position-conter" }, [
                    _c("div", { staticClass: "login-rewards" }, [
                      _c(
                        "div",
                        { staticClass: "login-rewards-grid" },
                        _vm._l(_vm.rewardPairs, function (pair, idx) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "reward-card" },
                            [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(_vm._s(pair.top.day)),
                              ]),
                              _c("div", { staticClass: "card-body" }, [
                                _c("img", {
                                  staticClass: "card-image",
                                  attrs: {
                                    src: require("@/assets/image/logo.png"),
                                    alt: "奖励图标",
                                  },
                                }),
                                _c("div", { staticClass: "card-desc" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(pair.top.title)
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(pair.top.desc) +
                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "reward-btn",
                                  class:
                                    pair.top.status === "未领取"
                                      ? "unclaimed"
                                      : "claimed",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(pair.top.status) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "card-bottom red-box" },
                                [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("img", {
                                      staticClass: "card-image",
                                      attrs: {
                                        src: require("@/assets/image/logo.png"),
                                        alt: "奖励图标",
                                      },
                                    }),
                                    _c("div", { staticClass: "card-desc" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(pair.bottom.title)
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(pair.bottom.desc) +
                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "reward-btn",
                                      class:
                                        pair.bottom.status === "未领取"
                                          ? "unclaimed"
                                          : "claimed",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(pair.bottom.status) +
                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "points-grid" },
                    _vm._l(_vm.pointsProducts, function (product) {
                      return _c(
                        "div",
                        { key: product.id, staticClass: "points-card" },
                        [
                          _c("div", { staticClass: "points-body" }, [
                            _c("img", {
                              staticClass: "points-image",
                              attrs: {
                                src: require("@/assets/image/" + product.image),
                                alt: product.name,
                              },
                            }),
                            _c("div", { staticClass: "points-desc" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(product.name) +
                                  "\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]),
                          _c("button", { staticClass: "reward-btn" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(product.points) +
                                "點\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
            _c("Footer"),
          ],
          1
        ),
        _c("TipsWindow", { ref: "tips" }),
        _c("RewardPopup", { ref: "rewardPopup" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rewards-header" }, [
      _c(
        "div",
        { staticStyle: { display: "flex", "align-items": "end", gap: "1ch" } },
        [
          _c("h2", { staticClass: "rewards-title" }, [_vm._v("登錄獎勵")]),
          _c("p", [_vm._v("登錄後即可領取獎勵")]),
        ]
      ),
      _c("div", { staticClass: "rewards-actions" }, [
        _c("button", { staticClass: "action-btn primary" }, [
          _vm._v("升級寶典"),
        ]),
        _c("button", { staticClass: "action-btn darkblue" }, [
          _vm._v("補簽獎勵"),
        ]),
        _c("button", { staticClass: "action-btn lightblue" }, [
          _vm._v("領取明細"),
        ]),
        _c("button", { staticClass: "action-btn lightyellow" }, [
          _vm._v("活動說明"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "rewards-header", staticStyle: { display: "inline" } },
      [
        _c(
          "div",
          {
            staticStyle: { display: "flex", "align-items": "end", gap: "1ch" },
          },
          [
            _c("h1", { staticClass: "rewards-title" }, [_vm._v("積分商城")]),
            _c("p", [_vm._v("積分：0")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "rewards-actions",
            staticStyle: { "margin-top": "10px" },
          },
          [
            _c("button", { staticClass: "action-btn primary" }, [
              _vm._v("全部"),
            ]),
            _c("button", { staticClass: "action-btn lightblue" }, [
              _vm._v("遊戲道具"),
            ]),
            _c("button", { staticClass: "action-btn lightyellow" }, [
              _vm._v("限定時装"),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }